
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"120","height":"120"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"84.3","y":"35","width":"26.48","height":"4.96","rx":"2.48","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M86.24 34.92l-3.38-6.26 4.92-8.77 19.53.07 4.92 8.77-3.39 6.27M83.31 29.28h28.47M100.04 19.74v-9.16h-5v9.16M97.54 9.75V0M103.04 40l6 68h-8.27M89.17 73.96L92.13 40M97.54 40v43.96M7.77 90.6h93M19.1 97.52h71"}}),_c('path',{attrs:{"d":"M100.78 90.33a51 51 0 00-93 .63v17h93z","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"d":"M18.21 107.1V91a41.41 41.41 0 0172.14-.4v16.65","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}})])
          )
        }
      }
    